import axios from "axios";
import {PostalCodeLookupRequest, PostalCodeLookupResponse} from "@/data/entities/postalCode";

/**
 * Separate instance: no credentials (cookies) to a third party.
 */
const postalCodeAxios = axios.create({
    baseURL: "https://gratis-postcodedata.nl/api",
    timeout: 5000,
});


/**
 * Powered by: https://gratis-postcodedata.nl/.
 * Rate limit: 60 requests/minute
 */
export const getPostalCodeData = ({
                                      postalCodeDigits,
                                      postalCodeLetters
                                  }: PostalCodeLookupRequest): Promise<PostalCodeLookupResponse> => (
    postalCodeAxios
        .get(`https://gratis-postcodedata.nl/api/postcode/${postalCodeDigits}${postalCodeLetters}`)
        .then(response => response.data)
);
